import { ListItem as MuiListItem, styled } from "@mui/material";

export const ListItem = styled(MuiListItem)(({ theme: { spacing } }) => ({
  display: "inline-grid",
  gridTemplateColumns:
    "minMax(300px, 500px) minMax(150px, 300px) minMax(1px, 90px) 180px",
  columnGap: spacing(2),
  alignItems: "flex-start",
}));
